import * as React from 'react';

class CardGrid extends React.Component {
    render() {
        return (
            <div className="card-grid ie11-grid-fix">
                {React.Children.map(this.props.children, child => (
                    <div className="card-grid__item">{child}</div>
                ))}
            </div>
        );
    }
}

export default CardGrid;
